module.exports = __webpack_public_path__ + "/login_ui/img/sk-5bb982ad138dc92ac3e7eba7a535582b.svg";